var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import apiClientServices from "..";
import { MEETING_ENDPOINTS } from "../../utils/endpoints";
function startAcsRecording(request) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield apiClientServices.post(MEETING_ENDPOINTS.START_ACS_RECORDING, request);
            return response.data;
        }
        catch (error) {
            throw error;
        }
    });
}
function stopAcsRecording(request) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield apiClientServices.post(MEETING_ENDPOINTS.STOP_ACS_RECORDING, request);
            return response.data;
        }
        catch (error) {
            throw error;
        }
    });
}
const acsRecordingService = {
    startAcsRecording,
    stopAcsRecording,
};
export default acsRecordingService;
